module.exports = __webpack_public_path__ + "resources/img/equipment_tab2_img.c74fb0b3edb71da5620adcd96ddf6bed.jpg";